import { Account, AccountStatus } from 'crono-fe-common/types/account';
import VerificationStatusType from 'crono-fe-common/types/enums/verificationStatusType';
import { Prospect } from 'crono-fe-common/types/prospect';
import { Suggestion } from 'crono-fe-common/types/suggestion';
import { SuggestionType } from 'crono-fe-common/types/enums/suggestionType';
import { WebsiteVisit } from 'crono-fe-common/types/websiteVisit';
import DeviceType from 'crono-fe-common/types/enums/deviceType';
import NotificationType from 'crono-fe-common/types/enums/notificationType';
import { SentimentAnalysisResult } from 'crono-fe-common/types/enums/sentimentAnalysisResult';
import { EmailLink } from 'crono-fe-common/types/emailLink';
import { Notification } from 'crono-fe-common/types/notification';

export const MOCK_PROSPECT: Prospect = {
  accountId: '',
  active: true,
  externalValues: null,
  fromContact: false,
  id: -1,
  objectId: '',
  owned: false,
  owner: false,
  ownerId: '',
  userId: -1,
  user: 'Alex Roggero',
  step: null,
  location: 'Milan, Italy',
  firstName: 'Johanna',
  lastName: 'Dow',
  name: 'Johanna Dow',
  title: 'Head of Sales',
  emailStatus: VerificationStatusType.UNKNOWN,
  actualStatus: null,
  optedOut: false,
  isSynced: false,
};

export const MOCK_ACCOUNT: Account = {
  id: -1,
  objectId: '',
  ownerId: '',
  userId: -1,
  user: 'Alex Roggero',
  name: 'ABC Inc.',
  actualStatus: AccountStatus.INACTIVE,
  prospects: [MOCK_PROSPECT],
  linkedin: '',
  currentSolution: '',
  externalValues: null,
  owned: false,
  isSynced: false,
};

export const MOCK_SUGGESTION: Suggestion = {
  id: -1,
  userId: -1,
  newCompanyName: 'Google',
  newCompanyPublicId: null,
  newRole: 'Account executive',
  type: SuggestionType.SuggestNewRole,
  subscriptionId: -1,
  accountId: '',
  prospectId: '',
  isCompleted: false,
  createdDate: new Date().toLocaleString(),
  completedDate: new Date().toLocaleString(),
  objectId: -1,
  active: true,
  isSkipped: false,
};

export const MOCK_WEBSITE_VISIT: WebsiteVisit = {
  id: -1,
  companyName: 'TechCorp',
  companyDomain: 'techcorp.com',
  companyIndustry: 'Software',
  companySize: '51-200',
  companyCountryCode: 'US',
  companyLocation: 'San Francisco, USA',
  companyLinkedinPublicId: 'techcorp',
  companyExternalId: 'ext-001',
  deviceType: DeviceType.DESKTOP,
  startedAt: new Date().toLocaleString(),
  endedAt: new Date().toLocaleString(),
  websiteVisitPages: [
    {
      pageUrl: 'https://techcorp.com/pricing',
      seenAt: new Date().toLocaleString(),
      visitDuration: 45,
    },
  ],
};

export const MOCK_NOTIFICATION: Notification = {
  id: -1,
  type: NotificationType.EMAIL_LINK_CLICKED,
  trackId: 'track-123',
  threadId: 'thread-xyz',
  emailId: 1001,
  emailReplyId: null,
  linkedinId: null,
  linkedinReplyId: null,
  sentimentAnalysisResult: SentimentAnalysisResult.POSITIVE,
  accountId: MOCK_ACCOUNT.objectId,
  prospectId: MOCK_PROSPECT.objectId,
  account: MOCK_ACCOUNT,
  prospect: MOCK_PROSPECT,
  created: new Date().toLocaleString(),
  read: false,
  data: { message: 'Email opened by prospect' },
};

export const MOCK_EMAIL_LINK: EmailLink = {
  url: 'https://example.com/product',
  trackId: 'track-abc',
  trackCount: 3,
  firstTrackDatetime: new Date(Date.now() - 3600000).toLocaleString(),
  lastTrackDatetime: new Date().toLocaleString(),
};
